
// NATIVE 

// INSTALLED 
import { setEmployeRedux, setEmployesRedux } from './employeeSlice';
import { checkingPreload, unCheckingPreload } from '../loading';
import { activeEmployeService, desactiveEmployeService, 
         getEmployeeDetailService, 
         getEmployesByPaginateService, getEmployesDataCreateService, 
         getEmployesService, saveEmployeeService } from '../../services/employee.service';
import { setCompanySelectRedux } from '../company';
import { setCargosSelectRedux } from '../cargos';
import { setPaymentFrecuencySelectRedux } from '../payment_frequency';
import { setEpsSelectRedux } from '../eps';
import { setBancosSelectRedux } from '../associated_bank';
import { setCajaCompensacionSelectRedux } from '../family_compensation_fund';
import { setCesantiasSelectRedux } from '../severance';
import { setCajaArlSelectRedux } from '../arl';
import { setPensionSelectRedux } from '../pension';
import { setTipoDocumentoSelectRedux } from '../type_document';
import { setMetodoPagoSelectRedux } from '../payment_method';
import { setSucursalesSelectRedux } from '../sucursal';


// CUSTOM 







export const getEmployeStore = (): any => {

    return async( dispatch: any ) => {
       

        await dispatch( checkingPreload() );

        const result = await  getEmployesService();

       
        if ( result.ok ) {

          await dispatch( setEmployesRedux(result.data) );
        }

        dispatch( unCheckingPreload() );

        return result;


    }

  
}



export const getEmployeDataCreateStore = (): any => {

  return async( dispatch: any ) => {
     

      await dispatch( checkingPreload() );

      const result = await  getEmployesDataCreateService();

     
      if ( result.ok ) {

        await dispatch( setCompanySelectRedux(result.data.company) );
        await dispatch( setCargosSelectRedux(result.data.cargos) );
        await dispatch( setPaymentFrecuencySelectRedux(result.data.paymentFrecuency) );
        await dispatch( setBancosSelectRedux(result.data.bancos) );
        await dispatch( setEpsSelectRedux(result.data.eps) );
        await dispatch( setCajaCompensacionSelectRedux(result.data.cajaCompensacion) );
        await dispatch( setCesantiasSelectRedux(result.data.cesantias) );
        await dispatch( setCajaArlSelectRedux(result.data.arls) );
        await dispatch( setPensionSelectRedux(result.data.pensiones) );
        await dispatch( setTipoDocumentoSelectRedux(result.data.tipoDocumentos) );
        await dispatch( setMetodoPagoSelectRedux(result.data.metodoPago) );
        await dispatch( setSucursalesSelectRedux(result.data.sucursales) );
      }
      
      dispatch( unCheckingPreload() );

      return result;


  }


}



export const getEmployesByPagination = (page:number): any => {

    return async( dispatch: any ) => {


      await dispatch( checkingPreload() );
      // await dispatch( hideIconRequestErrors() );
  
       

      const result = await  getEmployesByPaginateService(page);


      if ( result.ok ) {
           await dispatch( setEmployesRedux(result.data) );
      }
    
      dispatch( unCheckingPreload() );
      
      return result;
        
    }

}




export const saveEmployee = (employee: any, percentage:any): any => {

  return async( dispatch: any ) => {

      await dispatch( checkingPreload() );


        const data_employee =   {
              "employee_avatar": employee.foto_name_saved || 'default.png',
              "typeDocument": employee.document_type.value,
              "document_number": employee.document_number.toString(),
              "expedition_place": employee.expedition_place,
              "name": employee.name,
              "last_name": employee.last_name, 
              "birthdate": employee.date_of_birth,
              "gender": employee.gender.value,
              "civil_status":  employee.civil_status.value,
              "landline": employee.landline,
              "cell_phone": employee.cell_phone.toString(),
              "whatsapp": Number(employee.whatsapp),
              "rh": employee.rh.value,
              "dominance": employee.dominance.value,
              "allergies": employee.allergies,
              "cedula_name_saved_name": employee.cedula_name_saved_name,
              "housing_type": employee.housing_type.value,
              "address": employee.address,
              "neighborhood": employee.neighborhood,
              "stratum": employee.stratum.toString(),
              "cost_center": employee.cost_center.value,
              "compani": employee.compani.value,
              // "work_headquarters": employee.work_headquarters.value,
              "position": employee.cargo.value,
              "scholarship": employee.scholarship.value,
              "institution": employee.institution,
              "degree": employee.degree,
              "email": employee.email,
              "type_contract": employee.type_contract.value,
              "salary_base": employee.salary_base,
              "transport_subsidy": Number(employee.transport_subsidy),
              "paymentMethods": employee.payment_method.value,
              "paymentFrecuencies": employee.frecuency_payment.value,
              "associatedBank": employee.associated_bank.value,
              "account_number": employee.account_number,
              "file_certificate_bank_name": employee.certificate_banck_name_saved_name,
              "vacation_acumulate": employee.vacation_acumulate,
              "bonification_aditional": employee.bonification_aditional,
              "date_start_contract": employee.date_start_contract,
              "lunes": Number(employee.lunes),
              "martes": Number(employee.martes),
              "miercoles": Number(employee.miercoles),
              "jueves": Number(employee.jueves),
              "viernes": Number(employee.viernes),
              "sabado": Number(employee.sabado),
              "domingo": Number(employee.domingo),
              "festivo": Number(employee.festivo),  // "numOfBeneficiary": 0,
              // "numOfBeneficiary": 0,
              "eps": employee.eps.value, // eps
              "familyCompensationFund": employee.familyCompensation.value,
              "file_family_compensation_fund": employee.caja_compensacion_name_saved,
              "saving": employee.cesantias.value,
              "file_savings": employee.cesantias_name_saved,
              "retirement": employee.pension.value,
              "arl_name_saved": employee.arl_name_saved,
              "vista_domiciliaria": Number(employee.vista_domiciliaria),
              "visita_domiciliaria_name_saved": employee.visita_domiciliaria_name_saved,
              "prueba_psicotecnica": Number(employee.prueba_psicotecnica),
              "psicotecnica_name_saved": employee.psicotecnica_name_saved,
              "manipulacion_alimentos": Number(employee.manipulacion_alimentos),
              "manipulacion_alimentos_name_saved": employee.manipulacion_alimentos_name_saved,
              "trabajo_alturas": Number(employee.trabajo_alturas),
              "trabajo_altura_name_saved": employee.trabajo_altura_name_saved,
              "examen_medico": Number(employee.examen_medico),
              "examen_medico_name_saved": employee.examen_medico_name_saved,
              "contrato": Number(employee.contrato),
              "certificado_estudios": Number(employee.certificado_estudios),
              "certificado_estudios_name_saved": employee.certificado_estudios_name_saved,
              "certificado_laboral": Number(employee.certificado_laboral),
              "certificado_laboral_name_saved": employee.certificado_laboral_name_saved,
              "verificacion_adres": Number(employee.verificacion_adres),
              "verificacion_adres_name_saved": employee.verificacion_adres_name_saved,
              "antecedentes": Number(employee.antecedentes),
              "antecedentes_name_saved": employee.antecedentes_name_saved,
              "entrevista": Number(employee.entrevista),
              "entrevista_name_saved": employee.entrevista_name_saved,
              "sociodemografica": Number(employee.sociodemografica),
              "sociodemografica_name_saved": employee.sociodemografica_name_saved,
              "compromiso_sst": Number(employee.compromiso_sst),
              "compromiso_sst_name_saved": employee.compromiso_sst_name_saved,
              "cv_name_saved_name": employee.cv_name_saved_name,
              
              
          };

      
          console.log('nauanuanuanaunauna')
          console.log(data_employee)
        
          await dispatch( unCheckingPreload() );
      
       const result = await  saveEmployeeService(data_employee, percentage);


       return result;

      
      
  }
}



export const storeDesactiveEmploye = (employeId: string): any => {
    

  return async( dispatch: any ) => { 

      await dispatch( checkingPreload() );

      const result = await  desactiveEmployeService(employeId);

      
      dispatch( unCheckingPreload() );

      if ( result.ok ) {
          await dispatch( setEmployesRedux(result.data) );
      }

      return result;

  }

    
}




export const storeActiveEmploye = (employeId: string): any => {
    

  return async( dispatch: any ) => { 

      await dispatch( checkingPreload() );

      const result = await  activeEmployeService(employeId);

      
      dispatch( unCheckingPreload() );

      if ( result.ok ) {
          await dispatch( setEmployesRedux(result.data) );
      }

      return result;

  }

    
}



export const storeDetailEmployee = (employeeId: string): any => {

  return async( dispatch: any ) => {
     
    

      await dispatch( checkingPreload() );

      const result = await  getEmployeeDetailService(employeeId);

     
      if ( result.ok ) {

           await dispatch( setEmployeRedux(result.data) );
      }

      dispatch( unCheckingPreload() );

      return result;


  }


}




export const setEmployeeRedux = (employee: object[]): any => {

    return async( dispatch: any ) => {

        await dispatch( checkingPreload() );
        
          // dispatch( setEmployeRedux(employee) )
 
        await dispatch( unCheckingPreload() );
        
    }
}






